<template>
    <uiPage :blok="blok" :products="products" />
    <StoryblokComponent
        v-if="globalStore && globalStore.signInModal"
        :global="globalStore.global.content"
        :blok="globalStore.signInModal"
    />
    <StoryblokComponent
        v-if="globalStore && globalStore.resetPasswordModal"
        :global="globalStore.global.content"
        :blok="globalStore.resetPasswordModal"
    />
    <StoryblokComponent
        v-if="globalStore && globalStore.signUpModal"
        :global="globalStore.global.content"
        :blok="globalStore.signUpModal"
    />
</template>

<script setup lang="ts">
import { useGlobalStore } from '@nuxt-monorepo/base/app/store/global';

const config = useRuntimeConfig();

defineProps({ blok: Object, products: Object });

const route = useRoute();

if (route.params.IATA) {
    function normalizeAirportSlug(slug: string): string {
        // Storyblok provides the airport slug for port of seattle as 'sez', but the fetchAlgolia API expects 'zea'.
        if (slug === 'sez') return 'zea';
        return slug;
    }
    const initialDestination = await useUpdateAirportByCode(
        config.public,
        normalizeAirportSlug(`${route.params.IATA}`),
        false
    );
    provide('initialDestination', initialDestination);
}

await $getSession();

// Constant variable for access to quote store
const globalStore = useGlobalStore();
</script>
